import { Chevron } from '@factorialco/deprecated-design-system'

import { Document } from 'modules/documents/hooks/documents/useGetDocuments'

interface Props {
  documents: Document[]
  onClick: () => void
}

const RightChevron = ({ documents, onClick }: Props) => {
  if (documents.length <= 1) return null

  return (
    <button onClick={onClick}>
      <Chevron direction="right" type="secondary" />
    </button>
  )
}

export default RightChevron
